import Vue from 'vue'
import VueAxios from 'vue-axios'
import router from './router/router'
import './plugins/vuetify'
import './plugins/uuid'
import './plugins/filters'
import http from './plugins/http'
import store from './store/store'
import i18n from './plugins/vuei18n'
import websocket from './plugins/Websocket'
import App from './App.vue'

Vue.config.productionTip = false
Vue.use(VueAxios, http)
Vue.use(websocket,{url: process.env.VUE_APP_WEBSOCKET_URL})

if(websocket.isEnabled()){
  websocket.createConnection()
}

router.beforeEach((to, from, next) => {
  if (to.query.isMobileAppWebView == 'true') {
    store.state.isMobileAppWebView = true
  }

  document.title = i18n.t(to.meta.title) + ' - 2Form'
  next()
})

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
